import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../../components/Atomos/Inputs/Input";
import ButtonsCrud from "../../../components/Catalogs/ButtonsCrud";
import "../../../assets/css/AddCatalogs.css";
import CatalogSubTitle from "../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import SaveOverride from "../../../components/Catalogs/SaveOverride";
import { createCompany } from "../../../Services/Company";
import { createGuestSpeaker, deleteGuestSpeaker, updateGuestSpeaker } from "../../../Services/GuestSpeaker";
import { useDispatch } from "react-redux";
import {
  AddCompany,
  AddGuestSpeaker,
  DeleteGuestSpeaker,
  UpdateGuestSpeaker,
} from "../../../redux/catalogs/states";
import { IGuestSpeaker } from "../../../interfaces/models/IGuestSpeaker";
import InputImage from "../../../components/Atomos/InputImage/InputImage";
import { uploadImage } from "../../../utils/UploadImage";
import DropDownList from "../../../components/Atomos/DropDown/Dropdown";
import CompanyCreatableCombobox, {
  CompanySelection,
} from "../../../components/Catalogs/CompanyCreatableCombobox";
import { Honorary, Suffix, Title } from "../../../Enums/PersonEnums";
import { getCompanies } from "../../../Services/Company";
import { ICompany } from "../../../interfaces/models/ICompany";
import { ICountry } from "../../../interfaces/models/ICountry";
import { UseCountryList } from "../../../hooks/Catalogs";
import RadioButton from "../../../components/Atomos/Radio/RadioButton";
import TextArea from "../../../components/Atomos/Inputs/TextArea";
import {
  notifyCompanyCreated,
  notifyGuestSpeakerCreated,
  notifyGuestSpeakerCreatedWithNewCompany,
} from "../../../utils/catalogToasts";
import { toastError } from "../../../utils/toast";

const findCompanyByName = (name: string, list: ICompany[]) =>
  list.find(
    (c) =>
      (c.name || "").trim().toLowerCase() === name.trim().toLowerCase()
  );

interface iCatalogProps {
  mode: "add" | "edit";
}

type error = { error: boolean; msj: string };
type errors = {
  firstName: error;
  lastName: error;
  company: error;
  photo?: error;
};

const AddGuestSpeakerCatalog: React.FC<iCatalogProps> = (props) => {
  const crudNavegate = () => {
    navigate(-1);
  };

  const { state, pathname } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [guestSpeaker, setGuestSpeaker] = useState<IGuestSpeaker>(
    state
      ? { ...state }
      : {
          honorary: "",
          firstName: "",
          middleInitial: "",
          lastName: "",
          suffix: "",
          title: "",
          unlistedTitle: "",
          company: "",
          email: "",
          webPage: "",
          address: "",
          city: "",
          stateProvince: "",
          country: "",
          phone: "",
          fax: "",
          assistantName: "",
          assistantEmail: "",
          contactType: "Speaker",
          linkedinUrl: "",
          xUrl: "",
          facebookUrl: "",
          instagramUrl: "",
          photo: "",
          profile: "",
        }
  );
  const [photo, setPhoto] = useState<File | string | null>(
    state?.photo || null
  );
  const [buttonClicked, setButtonClicked] = useState("");
  const [errors, setErrors] = useState<errors>({
    firstName: { error: false, msj: "" },
    lastName: { error: false, msj: "" },
    company: { error: false, msj: "" },
  });
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [saveOverrideOpen, setSaveOverrideOpen] = useState(false);
  const [companiesData, setCompaniesData] = useState<ICompany[]>([]);
  const [pendingNewCompany, setPendingNewCompany] = useState(false);
  const [companyLogo, setCompanyLogo] = useState<File | string | null>(null);
  const [companyCreateError, setCompanyCreateError] = useState("");
  const { countryData } = UseCountryList();
  
  type listobj = { id: string; name: string };
  const [selectedCompany, setSelectedCompany] = useState<listobj>({
    id: state?.company ?? '',
    name: state?.companyName ?? "",
  });
  const [selectedCountry, setSelectedCountry] = useState<listobj>({
    id: state?.country ?? '',
    name: state?.countryName ?? "",
  });
  
  useEffect(() => {
    getCompanies().then((companies) => setCompaniesData(companies));
  }, []);
  
  useEffect(() => {
    if (state && companiesData.length) {
      const company = companiesData.find((c) => c.name === state?.company);
      if (company) {
        setSelectedCompany({ id: company.id, name: company.name });
      }
    }
  }, [companiesData, state]);
  
  useEffect(() => {
    if (state && countryData.length) {
      const country = countryData.find((c) => c.name === state?.country);
      if (country) {
        setSelectedCountry({ id: country.id, name: country.name });
      }
    }
  }, [countryData, state]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      errors.firstName.error ||
      errors.lastName.error ||
      errors.company.error ||
      !!errors.photo?.error
    ) {
      validateForm();
    }
  }, [guestSpeaker, photo, selectedCompany, selectedCountry, pendingNewCompany]);

  useEffect(() => {
    if (
      !errors.firstName.error &&
      !errors.lastName.error &&
      !errors.company.error &&
      !errors.photo?.error
    ) {
      setSaveOverrideOpen(false);
    }
  }, [errorFields]);

  const validateForm = (): boolean => {
    const newerrors: errors = {
      firstName:
        guestSpeaker?.firstName === ""
          ? { error: true, msj: "Name is required" }
          : { error: false, msj: "" },
      lastName:
        guestSpeaker?.lastName === ""
          ? { error: true, msj: "Last Name is required" }
          : { error: false, msj: "" },
      company:
        selectedCompany.name.trim() === ""
          ? { error: true, msj: "Company is required" }
          : !selectedCompany.id && !pendingNewCompany
          ? {
              error: true,
              msj: "Select an existing company or enter a new company name",
            }
          : { error: false, msj: "" },
    };
    let merged: errors = newerrors;
    setErrors((prev) => {
      merged = { ...newerrors };
      if (prev.photo?.error) {
        merged = { ...merged, photo: prev.photo };
      }
      return merged;
    });
    const valid = Object.values(merged).every((field) => !field.error);
    setErrorFields(
      (Object.keys(merged) as (keyof errors)[]).filter(
        (key) => merged[key]?.error
      )
    );

    if (!valid) {
      setSaveOverrideOpen(true);
    }

    return valid;
  };

  const handleButtonClick = (action: string) => {
    setButtonClicked(action);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    switch (buttonClicked) {
      case "delete":
        await handleDelete();
        break;
      case "saveOverride":
        if (props.mode === "add") {
          await handleCreate();
        } else {
          await handleUpdate();
        }
        break;
      case "saveButton":
        await handleCreate();
        break;
      case "updateButton":
        if (validateForm()) {
          await handleUpdate();
        }
        break;
      default:
        // Handle unexpected buttonClicked values if needed
        break;
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setGuestSpeaker({ ...guestSpeaker, [e.target.name]: e.target.value });
  };

  const handleTextAreaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setGuestSpeaker((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCompanyCreatableChange = (s: CompanySelection) => {
    setSelectedCompany({ id: s.id, name: s.name });
    setPendingNewCompany(s.pendingNew);
    setGuestSpeaker((prev) => ({ ...prev, company: s.id || "" }));
    setCompanyCreateError("");
    if (!s.pendingNew) {
      setCompanyLogo(null);
    }
  };

  const handleCompanyLogoChange = useCallback(
    (img: string | File | null) => {
      setCompanyLogo(img);
    },
    []
  );

  const handleSetSelectedCountry = (value: any) => {
    setSelectedCountry(value);
    setGuestSpeaker({ ...guestSpeaker, country: value?.name || "" });
  };

  const handleDropdownChange = (fieldName: string) => (value: any) => {
    const stringValue =
      typeof value === "object" && value !== null && "name" in value
        ? value.name
        : value || "";
    setGuestSpeaker({ ...guestSpeaker, [fieldName]: stringValue });
  };

  const handleLogoChange = useCallback((photo: string | File | null) => {
    setPhoto(photo);
  }, []);

  const handleImageUpload = useCallback(
    async (
      image: File | string | null | undefined,
      companyId: string
    ): Promise<string | undefined> => {
      if (image instanceof File) {
        const url = await uploadImage(image, companyId, "company/logos/");
        return url;
      }
      return typeof image === "string" ? image : undefined;
    },
    []
  );

  const generateGuestSpeakerData = (
    companyId = selectedCompany.id,
    companyName = selectedCompany.name
  ) => ({
    ...guestSpeaker,
    companyName,
    company: companyId,
    country: selectedCountry.id,
    countryName: selectedCountry.name,
  });

  const resolveCompanyForSave = async (): Promise<{
    id: string;
    name: string;
    wasCreated: boolean;
    company?: ICompany;
  } | null> => {
    if (selectedCompany.id) {
      return {
        id: selectedCompany.id,
        name: selectedCompany.name,
        wasCreated: false,
      };
    }

    if (!pendingNewCompany) {
      return null;
    }

    const trimmedName = selectedCompany.name.trim();
    const freshCompanies = await getCompanies();
    const existing = findCompanyByName(trimmedName, freshCompanies);

    if (existing) {
      setCompaniesData(freshCompanies);
      setSelectedCompany({ id: existing.id, name: existing.name });
      setPendingNewCompany(false);
      setCompanyLogo(null);
      setCompanyCreateError("");
      return {
        id: existing.id,
        name: existing.name,
        wasCreated: false,
      };
    }

    let logoUrl = "";
    if (companyLogo instanceof File) {
      const uploaded = await uploadImage(companyLogo, "new", "company/logos/");
      if (!uploaded) {
        setCompanyCreateError("Failed to upload company logo");
        toastError("Failed to upload company logo.");
        return null;
      }
      logoUrl = uploaded;
    }

    try {
      const newCo = await createCompany({
        id: "",
        name: trimmedName,
        logo: logoUrl,
        squareLogo: false,
      });
      dispatch(AddCompany(newCo));
      setCompaniesData((prev) => [...prev, newCo]);
      setSelectedCompany({ id: newCo.id, name: newCo.name });
      setPendingNewCompany(false);
      setCompanyLogo(null);
      setCompanyCreateError("");
      return {
        id: newCo.id,
        name: newCo.name,
        wasCreated: true,
        company: newCo,
      };
    } catch (error) {
      console.error("Error creating company:", error);
      setCompanyCreateError("Could not create company. Please try again.");
      toastError("Could not create company. Please try again.");
      return null;
    }
  };

  const handleCreate = async () => {
    if (!validateForm()) {
      return;
    }
    setCompanyCreateError("");

    try {
      const resolvedCompany = await resolveCompanyForSave();
      if (!resolvedCompany) {
        return;
      }

      const companyIdForSpeaker = resolvedCompany.id;
      const companyNameForSpeaker = resolvedCompany.name;

      const guestSpeakerId = guestSpeaker.id || "new";
      let photoUrl: string | undefined;

      if (photo) {
        photoUrl = await handleImageUpload(photo, guestSpeakerId);
        if (photo instanceof File && !photoUrl) {
          setErrors((prev) => ({
            ...prev,
            photo: { error: true, msj: "Failed to upload photo" },
          }));
          return;
        }
      }

      const { id, ...rest } = guestSpeaker;
      const guestSpeakerData: Omit<IGuestSpeaker, "id"> & { id?: string } = {
        ...rest,
        companyName: companyNameForSpeaker,
        company: companyIdForSpeaker,
        country: selectedCountry.id,
        countryName: selectedCountry.name,
        ...(photoUrl && { photo: photoUrl }),
      };
      const response = await createGuestSpeaker(guestSpeakerData as IGuestSpeaker);
      dispatch(AddGuestSpeaker(response));

      if (resolvedCompany.wasCreated && resolvedCompany.company) {
        notifyGuestSpeakerCreatedWithNewCompany(resolvedCompany.company);
      } else {
        notifyGuestSpeakerCreated();
      }

      crudNavegate();
    } catch (error) {
      console.error("Error creating guest speaker:", error);
      setCompanyCreateError("Could not complete save. Please try again.");
      toastError("Could not create Guest Speaker. Please try again.");
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
      return;
    }
    setCompanyCreateError("");

    try {
      const resolvedCompany = await resolveCompanyForSave();
      if (!resolvedCompany) {
        return;
      }

      const guestSpeakerId = guestSpeaker.id || "new";
      const photoUrl = await handleImageUpload(photo, guestSpeakerId);

      const guestSpeakerData = {
        ...generateGuestSpeakerData(resolvedCompany.id, resolvedCompany.name),
        ...(photoUrl && { photo: photoUrl }),
      };
      await updateGuestSpeaker(guestSpeakerData);
      dispatch(UpdateGuestSpeaker(guestSpeakerData));

      if (resolvedCompany.wasCreated && resolvedCompany.company) {
        notifyCompanyCreated(resolvedCompany.company);
      }

      crudNavegate();
    } catch (error) {
      console.error("Error updating guest speaker:", error);
      toastError("Could not save Guest Speaker. Please try again.");
    }
  };

  const handleDelete = async () => {
    try {
      const guestSpeakerData = generateGuestSpeakerData();
      await deleteGuestSpeaker(guestSpeakerData.id ?? "");
      dispatch(DeleteGuestSpeaker(guestSpeakerData.id ?? ""));
      crudNavegate();
    } catch (error) {
      console.error("Error deleting guest speaker:", error);
    }
  };

  return (
    <main className={`${saveOverrideOpen ? "pt-7 md:pt-9 " : ""}`}>
      <form onSubmit={handleSubmit}>
        <SaveOverride
          fields={errorFields}
          handleButtonClick={handleButtonClick}
          open={saveOverrideOpen}
          close={() => {
            setSaveOverrideOpen(!saveOverrideOpen);
          }}
        />
        <article className="articleSection ">
          <section className="formsectionNTitle">
            <CatalogSubTitle
              title=" Guest Speaker Information"
              className="text-accent-Default-dark"
            />
            <div className="formsection w-full grid grid-cols-8 lg:grid-cols-11 gap-5">
              <div className=" col-span-10 md:col-span-2 lg:col-span-1">
                <DropDownList
                  title="Honorary"
                  required={false}
                  data={Object.values(Honorary).map((value) => ({
                    name: value,
                  }))}
                  selectedObjst={guestSpeaker.honorary}
                  seter={handleDropdownChange("honorary")}
                  error={false}
                  errormsj={""}
                />
              </div>
              <div className=" col-span-10 md:col-span-4 lg:col-span-4">
                <Input
                  name="firstName"
                  value={guestSpeaker.firstName}
                  required={true}
                  title="First Name"
                  error={errors.firstName.error}
                  errorMsj={errors.firstName.msj}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-10 md:col-span-2 lg:col-span-1">
                <Input
                  name="middleInitial"
                  value={guestSpeaker.middleInitial}
                  title="Middle Initial"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-10 md:col-span-4 lg:col-span-4">
                <Input
                  name="lastName"
                  value={guestSpeaker.lastName}
                  required={true}
                  title="Last Name"
                  error={errors.lastName.error}
                  errorMsj={errors.lastName.msj}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-10 md:col-span-4 lg:col-span-1">
                <DropDownList
                  title="Suffix"
                  required={false}
                  data={Object.values(Suffix).map((value) => ({
                    name: value,
                  }))}
                  selectedObjst={guestSpeaker.suffix}
                  seter={handleDropdownChange("suffix")}
                  error={false}
                  errormsj={""}
                />
              </div>
            </div>
            <div className="formsection w-full grid grid-cols-10 gap-5">
              <div className=" col-span-10 md:col-span-5">
                <DropDownList
                  title="Title"
                  required={false}
                  data={Object.values(Title).map((value) => ({
                    name: value,
                  }))}
                  selectedObjst={guestSpeaker.title}
                  seter={handleDropdownChange("title")}
                  error={false}
                  errormsj=""
                />
              </div>
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="unlistedTitle"
                  value={guestSpeaker.unlistedTitle}
                  title="Unlisted Title"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="formsection w-full grid grid-cols-10 gap-5">
              <div className=" col-span-10 md:col-span-5">
                <CompanyCreatableCombobox
                  companies={companiesData}
                  selection={{
                    id: selectedCompany.id,
                    name: selectedCompany.name,
                    pendingNew: pendingNewCompany,
                  }}
                  onSelectionChange={handleCompanyCreatableChange}
                  required={true}
                  error={errors.company.error}
                  errormsj={errors.company.msj}
                />
                {companyCreateError ? (
                  <p className="mt-2 text-base font-medium text-primary">
                    {companyCreateError}
                  </p>
                ) : null}
              </div>
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="email"
                  value={guestSpeaker.email}
                  title="Email"
                  required={false}
                  error={false}
                  errorMsj=""
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {pendingNewCompany ? (
              <div className="formsection w-full grid grid-cols-10 gap-5">
                <div className=" col-span-10 md:col-span-5">
                  <InputImage
                    title="Company logo"
                    setImage={handleCompanyLogoChange}
                    photo={
                      typeof companyLogo === "string" ? companyLogo : ""
                    }
                    error={false}
                    dynamicSize={true}
                    maxsize={25}
                    maxPreviewWidth={240}
                    maxPreviewHeight={120}
                  />
                </div>
              </div>
            ) : null}
            <div className="formsection w-full grid grid-cols-10 gap-5">
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="webPage"
                  value={guestSpeaker.webPage}
                  title="Web Page"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="address"
                  value={guestSpeaker.address}
                  title="Address"
                  required={false}
                  error={false}
                  errorMsj=""
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="formsection w-full grid grid-cols-12 gap-5">
              <div className=" col-span-12 md:col-span-4">
                <Input
                  name="city"
                  value={guestSpeaker.city}
                  title="City"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-12 md:col-span-4">
                <Input
                  name="stateProvince"
                  value={guestSpeaker.stateProvince}
                  title="State Province"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-12 md:col-span-4">
                <DropDownList
                  title="Country"
                  getid
                  required={false}
                  data={
                    countryData.map((country: ICountry) => ({
                      name: country.name,
                      id: country.id,
                    })) || []
                  }
                  selectedObjst={selectedCountry.name}
                  seter={handleSetSelectedCountry}
                  error={false}
                  errormsj=""
                />
              </div>
            </div>
            <div className="formsection w-full grid grid-cols-10 gap-5">
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="phone"
                  value={guestSpeaker.phone}
                  title="Phone"
                  required={false}
                  error={false}
                  errorMsj=""
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="fax"
                  value={guestSpeaker.fax}
                  title="Fax"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="formsection w-full grid grid-cols-10 gap-5">
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="assistantName"
                  value={guestSpeaker.assistantName}
                  title="Assistant Name"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" col-span-10 md:col-span-5">
                <Input
                  name="assistantEmail"
                  value={guestSpeaker.assistantEmail}
                  title="Assistant Email"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="flex formsection w-full flex-col md:flex-row">
              <div className="flex formsection flex-col">
                <div className="flex formsection">
                  <div>
                    <span className="text-gray-font text-lg font-medium">
                      Contact Type:
                    </span>
                  </div>
                  <RadioButton
                    index={0}
                    text={"Expert"}
                    selected={guestSpeaker.contactType === "Expert"}
                    handleRadioButtonChange={() =>
                      setGuestSpeaker({
                        ...guestSpeaker,
                        contactType: "Expert",
                      })
                    }
                    name="contactType"
                  />
                  <RadioButton
                    index={1}
                    text={"Invited Registrant"}
                    selected={guestSpeaker.contactType === "Invited Registrant"}
                    handleRadioButtonChange={() =>
                      setGuestSpeaker({
                        ...guestSpeaker,
                        contactType: "Invited Registrant",
                      })
                    }
                    name="contactType"
                  />
                  <RadioButton
                    index={2}
                    text={"Press Contact"}
                    selected={guestSpeaker.contactType === "Press Contact"}
                    handleRadioButtonChange={() =>
                      setGuestSpeaker({
                        ...guestSpeaker,
                        contactType: "Press Contact",
                      })
                    }
                    name="contactType"
                    disabled={true}
                  />
                  <RadioButton
                    index={3}
                    text={"Speaker"}
                    selected={guestSpeaker.contactType === "Speaker"}
                    handleRadioButtonChange={() =>
                      setGuestSpeaker({
                        ...guestSpeaker,
                        contactType: "Speaker",
                      })
                    }
                    name="contactType"
                  />
                  <RadioButton
                    index={4}
                    text={"General Counsel"}
                    selected={guestSpeaker.contactType === "General Counsel"}
                    handleRadioButtonChange={() =>
                      setGuestSpeaker({
                        ...guestSpeaker,
                        contactType: "General Counsel",
                      })
                    }
                    name="contactType"
                  />
                </div>
              </div>
            </div>
            <CatalogSubTitle
              title=" Social Media Information"
              className="text-accent-Default-dark"
            />
            <div className="formsection flex w-full flex-col lg:flex-row">
              <div className=" w-full lg:w-1/2">
                <Input
                  name="linkedinUrl"
                  value={guestSpeaker.linkedinUrl}
                  title="LinkedIn URL"
                  placeholder="https://www.linkedin.com/in/username"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" w-full lg:w-1/2">
                <Input
                  name="xUrl"
                  value={guestSpeaker.xUrl}
                  title="X URL"
                  placeholder="https://www.twitter.com/username"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" w-full lg:w-1/2">
                <Input
                  name="facebookUrl"
                  value={guestSpeaker.facebookUrl}
                  title="Facebook URL"
                  placeholder="https://www.facebook.com/yourname"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
              <div className=" w-full lg:w-1/2">
                <Input
                  name="instagramUrl"
                  value={guestSpeaker.instagramUrl}
                  title="Instagram URL"
                  placeholder="https://www.instagram.com/username"
                  error={false}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <CatalogSubTitle
              title=" Profile Headshot"
              className="text-accent-Default-dark"
            />
            <div className="formsection flex w-full flex-col lg:flex-row">
              <div className="w-full lg:w-1/2">
                <InputImage
                  title="Photo"
                  setImage={handleLogoChange}
                  photo={typeof photo === "string" ? photo : ""}
                  error={false}
                  adaptiveShape
                />
              </div>
              <div className="w-full lg:w-1/2">
                <TextArea
                  name="profile"
                  value={guestSpeaker.profile}
                  title="Profile"
                  error={false}
                  maxChars={4000}
                  characterCount={true}
                  onChange={handleTextAreaChange}
                />
              </div>
            </div>
          </section>
          <ButtonsCrud
            Catalog="Guest Speaker"
            mode={props.mode}
            id={id ? id : ""}
            disabled={
              errors.firstName.error ||
              errors.lastName.error ||
              errors.company.error ||
              !!errors.photo?.error
            }
            actionButton={handleButtonClick}
            onDelete={handleDelete}
            state={state}
            newState={guestSpeaker}
          />
        </article>
      </form>
    </main>
  );
};
export default AddGuestSpeakerCatalog;
